import React from "react";

import {flushSync} from "react-dom";

import {ThemeProvider, extendTheme as extendMaterialTheme} from '@mui/material/styles';
import {InputAdornment, ListSubheader, MenuItem, Select, TextField} from "@mui/material";

import {styled} from "@mui/joy/styles";
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

import FormLabel from "@mui/joy/FormLabel";
import {Slider, Stack, Switch} from "@mui/joy";
import Input from "@mui/joy/Input";
import IconButton from "@mui/joy/IconButton";
import Grid from "@mui/joy/Grid";
import CardContent from "@mui/joy/CardContent";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import Card from "@mui/joy/Card";
import Tooltip from "@mui/joy/Tooltip";
import ButtonGroup from "@mui/joy/ButtonGroup";
import Button from "@mui/joy/Button";

// components
import {deleteArrayItemByKeyValue, findArrayItemsByKeyValue,} from "../../utils/misc";

// icons
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from '@mui/icons-material/Cancel';


export const StyledInput = styled('input')(
    {
        border: 'none',
        minWidth: 0,
        outline: 0,
        padding: 0,
        paddingTop: '1em',
        flex: 1,
        color: 'inherit',
        backgroundColor: 'transparent',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
        textOverflow: 'ellipsis',
        '&::placeholder': {
        opacity: 0,
        transition: '0.1s ease-out',
    },
        '&:focus::placeholder': {
        opacity: 1,
    },
        '&:focus ~ label, &:not(:placeholder-shown) ~ label, &:-webkit-autofill ~ label': {
        top: '0.5rem',
        fontSize: '0.75rem',
    },
        '&:focus ~ label': {
        //color: 'var(--Input-focusedHighlight)',
    },
        '&:-webkit-autofill': {
        alignSelf: 'stretch', // to fill the height of the root slot
    },
        '&:-webkit-autofill:not(* + &)': {
        marginInlineStart: 'calc(-1 * var(--Input-paddingInline))',
        paddingInlineStart: 'var(--Input-paddingInline)',
        borderTopLeftRadius:
          'calc(var(--Input-radius) - var(--variant-borderWidth, 0px))',
        borderBottomLeftRadius:
          'calc(var(--Input-radius) - var(--variant-borderWidth, 0px))',
    },
});


export const StyledLabel = styled('label')(({ theme }) => ({
    position: 'absolute',
    lineHeight: 1,
    top: 'calc((var(--Input-minHeight) - 1em) / 2)',
    transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
}));


export const InnerInput = React.forwardRef(function InnerInput(props, ref) {
    const id = React.useId();
    return (
        <React.Fragment>
            <StyledInput {...props} ref={ref} id={id} />
            <StyledLabel htmlFor={id}>{props.label}</StyledLabel>
        </React.Fragment>
    );
});


export class CustomDateWrapperField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            api_value: this.props.defaultValue?dayjs(this.props.defaultValue).format(this.props.format):null,
            value: this.props.defaultValue?dayjs(this.props.defaultValue):null
        }
        if (localStorage.getItem("joy-mode") === 'dark'){
            this.theme = extendMaterialTheme({
                colorSchemes:{
                    dark: true,
                }
            })
        }
        else {
            this.theme = extendMaterialTheme({})
        }
    }

    set_api_value(value){
        this.setState(
            {
                api_value: value?dayjs(value).format(this.props.format):null,
                value: value?value:null,
            }
        )
        if (this.props.callBack){
            this.props.callBack()
        }
    }

    render() {
        return(
            <ThemeProvider theme={this.theme}>
                <Stack
                    direction={'row'}
                    useFlexGap
                    sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: 'wrap'
                    }}
                >
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        adapterLocale="ru"
                    >
                        <this.props.component
                            disabled={this.props.disabled}
                            sx={{
                                flexGrow: 4
                            }}
                            label={this.props.label}
                            required={this.props.required}
                            value={this.state.value}
                            onChange={(newValue, context) => {
                                this.set_api_value(newValue);
                            }}
                            disablePast={this.props.disablePast}
                        />
                    </LocalizationProvider>
                    {/*{*/}
                    {/*    !this.props.disabled?*/}
                    {/*        <CancelIcon*/}
                    {/*            color={'warning'}*/}
                    {/*            sx={{*/}
                    {/*                ml: 0.5*/}
                    {/*            }}*/}
                    {/*            onClick={() => (this.set_api_value(null))}*/}
                    {/*        />:*/}
                    {/*        null*/}
                    {/*}*/}
                </Stack>
                <input
                    required={this.props.required}
                    disabled={this.props.disabled}
                    type={'text'}
                    value={this.state.api_value?this.state.api_value:''}
                    name={this.props.name}
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                />
            </ThemeProvider>
        )
    }
}


export class CustomSelectField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            'displayedOptions': []
        }
        this.defaultValue = null;
        if (this.props.options.length > 0){
            if (typeof this.props.options[0].value === 'number'){
                let intValue = parseInt(this.props.defaultValue);
                if (isNaN(intValue)){
                    this.defaultValue = this.props.defaultValue;
                }
                else {
                    this.defaultValue = intValue;
                }
            }
            else {
                this.defaultValue = this.props.defaultValue;
            }
        }
        if (localStorage.getItem("joy-mode") === 'dark'){
            this.theme = extendMaterialTheme({
                colorSchemes:{
                    dark: true,
                }
            })
        }
        else {
            this.theme = extendMaterialTheme({
            })
        }
    }

    componentDidMount() {
        this.setState(
            {
                'displayedOptions': this.props.options
            }
        );
    }

    containsText(text, searchText) {
        return(
            text.toLowerCase().indexOf(searchText.toLowerCase()) > -1
        )
    }

    filterOptions(text) {
        this.setState(
            {
                'displayedOptions': this.props.options.filter((option) => this.containsText(option.label, text))
            },
        );
    }

    onChange(event){
        if (this.props.callBack){
            this.props.callBack(event)
        }
    }

    render() {
        return (
            <ThemeProvider theme={this.theme}>
                <Select
                    sx={{
                        padding: 1,
                    }}
                    slots={{ input: InnerInput }}
                    onChange={this.onChange.bind(this)}
                    slotProps={{
                        input:
                            {
                                label: this.props.label,
                                placeholder: '',
                                type: 'text',
                                required: this.props.required,
                                name: this.props.name,
                                disabled: this.props.disabled,
                            }
                        }}
                    MenuProps={{ autoFocus: false }}
                    required={this.props.required}
                    label={this.props.label}
                    name={this.props.name}
                    onClose={() => this.filterOptions.bind(this, '')}
                    defaultValue={
                        this.defaultValue?this.defaultValue:''
                    }
                >
                    <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => this.filterOptions(e.target.value)}
                            onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </ListSubheader>
                    {this.props.empty?
                        <MenuItem key={'empty-value'} value={this.props.emptyValue || 'NaN'}>
                            {this.props.emptyLabel?this.props.emptyLabel:'---'}
                        </MenuItem>:
                        null
                    }
                    {
                        this.state.displayedOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))
                    }
                </Select>
            </ThemeProvider>
        )
    }
}


export class CustomMultiSelectField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            'displayedOptions': []
        }
        if (localStorage.getItem("joy-mode") === 'dark'){
            this.theme = extendMaterialTheme({
                colorSchemes:{
                    dark: true,
                }
            })
        }
        else {
            this.theme = extendMaterialTheme({
            })
        }
    }

    componentDidMount() {
        this.setState(
            {
                'displayedOptions': this.props.options
            }
        );
    }

    containsText(text, searchText) {
        return(
            text.toLowerCase().indexOf(searchText.toLowerCase()) > -1
        )
    }

    filterOptions(text) {
        this.setState(
            {
                'displayedOptions': this.props.options.filter((option) => this.containsText(option.label, text))
            },
        );
    }

    onChange(event){
        if (this.props.callBack){
            this.props.callBack(event)
        }
    }

    render() {
        return (
            <ThemeProvider theme={this.theme}>
                <Select
                    sx={{
                        padding: 1,
                    }}
                    onChange={this.onChange.bind(this)}
                    MenuProps={{ autoFocus: false }}
                    defaultValue={this.props.defaultValue?this.props.defaultValue:[]}
                    required={this.props.required}
                    label={this.props.label}
                    name={this.props.name}
                    onClose={() => this.filterOptions.bind(this, '')}
                    multiple={true}
                    slots={{ input: InnerInput }}
                    slotProps={{ input:
                        {
                            label: this.props.label,
                            placeholder: '',
                            type: 'text',
                            required: this.props.required,
                            name: this.props.name,
                            // defaultValue: value,
                        }
                    }}
                >
                    <ListSubheader>
                        <TextField
                            size="small"
                            autoFocus
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                    <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(e) => this.filterOptions(e.target.value)}
                            onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                                e.stopPropagation();
                            }
                            }}
                        />
                    </ListSubheader>
                    {
                        this.state.displayedOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))
                    }
                </Select>
            </ThemeProvider>
        )
    }
}


export class CustomMultiSelectBoxesField extends React.Component {
    constructor(props) {
        super(props);
        let options = this.props.options;
        let selectedOptions = [];
        for (let value of this.props.defaultValue?this.props.defaultValue:[]) {
            selectedOptions = [
                ...selectedOptions,
                ...findArrayItemsByKeyValue(options, 'value', value)
            ]
            options = deleteArrayItemByKeyValue(
                options,
                'value',
                value
            );
        }
        this.state = {
            availableOptions: options,
            displayedOptions: options,
            selectedOptions: selectedOptions,
            filterText: null,
        }
    }

    containsText(text, searchText) {
        return(
            text.toLowerCase().indexOf(searchText.toLowerCase()) > -1
        )
    }

    filterOptions(text) {
        this.setState(
            {
                filterText: text,
                displayedOptions: this.state.availableOptions.filter(
                    (option) => this.containsText(option.label, text)
                )
            },
        );
    }

    selectOption(option){
        if (this.props.disabled){
            return
        }
        let selectedOptions = this.state.selectedOptions;
        selectedOptions.push(option);
        let availableOptions = this.state.availableOptions;
        availableOptions = deleteArrayItemByKeyValue(
            availableOptions,
            'value',
            option.value
        );
        this.setState(
            {
                availableOptions: availableOptions,
                selectedOptions: selectedOptions,
                displayedOptions: this.state.filterText?availableOptions.filter(
                    (option) => this.containsText(option.label, this.state.filterText)
                ):availableOptions,
            }
        );
        if (this.props.callBack){
            this.props.callBack()
        }
    }

    unselectOption(option){
        if (this.props.disabled){
            return
        }
        let availableOptions = this.state.availableOptions;
        availableOptions.push(option);
        let selectedOptions = this.state.selectedOptions;
        selectedOptions = deleteArrayItemByKeyValue(
            selectedOptions,
            'value',
            option.value
        );
        this.setState(
            {
                availableOptions: availableOptions,
                selectedOptions: selectedOptions,
                displayedOptions: this.state.filterText?availableOptions.filter(
                    (option) => this.containsText(option.label, this.state.filterText)
                ):availableOptions,
            }
        );
        if (this.props.callBack){
            this.props.callBack()
        }
    }

    render() {
        return (
            <Stack
                spacing={1}
            >
                <FormLabel>
                    {this.props.label}
                </FormLabel>
                <input
                    type={'text'}
                    value={this.state.selectedOptions.map((o) => (o.value)).join(",")}
                    name={this.props.name}
                    required={this.props.required}
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                />
                <Grid
                    container
                    spacing={0}
                >
                    <Grid xs={12}>
                        <Input
                            size="small"
                            fullWidth
                            startDecorator={
                                <SearchIcon sx={{ml: 1}} />
                            }
                            onChange={(e) => this.filterOptions(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid xs={6}
                        sx={{pl: 0}}
                    >
                        <Typography
                            sx={{mb: 1}}
                        >
                            Варианты:
                        </Typography>
                        <Card
                            sx={{
                                height: '200px',
                                overflowY: 'scroll'
                            }}
                            size={'sm'}
                        >
                            <CardContent>
                                {
                                    this.state.displayedOptions.map(option => (
                                        <Tooltip
                                            color="warning"
                                            title={option.label}
                                            variant="solid"
                                            size={'sm'}
                                            placement="right-start"
                                        >
                                            <Chip
                                                key={option.value}
                                                onClick={() => (this.selectOption(option))}
                                            >
                                                {option.label}
                                            </Chip>
                                        </Tooltip>
                                    ))
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid
                        xs={6}
                        sx={{pr: 0}}
                    >
                        <Typography
                            sx={{mb: 1}}
                        >
                            Выбрано:
                        </Typography>
                        <Card
                            sx={{
                                height: '200px',
                                overflowY: 'scroll'
                            }}
                        >
                            <CardContent>

                                {
                                    this.state.selectedOptions.map(option => (
                                        <Tooltip
                                            color="warning"
                                            title={option.label}
                                            variant="solid"
                                            size={'sm'}
                                            placement="right-start"
                                        >
                                            <Chip
                                                key={option.value}
                                                onClick={() => (this.unselectOption(option))}
                                            >
                                                {option.label}
                                            </Chip>
                                        </Tooltip>
                                    ))
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

            </Stack>
        )
    }
}


export class CustomSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.value
        }
    }

    setChecked(){
        this.setState({
            checked: !this.state.checked
        });
    }

    render() {
        return(
            <>
                <FormLabel>{this.props.label}</FormLabel>
                <Switch
                    checked={this.state.checked}
                    onChange={this.setChecked.bind(this)}
                    slots={{
                        input: null,
                    }}
                />

                <input
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                    required={this.props.required}
                    name={this.props.name}
                    checked={this.state.checked}
                    value={this.state.checked?'true':'false'}
                />
            </>
        )
    }
}



export class CustomButtonSwitch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.value
        }
    }

    setChecked(value){
        this.setState({
            checked: value
        });
        if (this.props.callBack){
            this.props.callBack()
        }
    }

    render() {
        return(
            <Stack>
                <Typography
                    sx={{
                        position: 'absolute',
                        top: '-10px',
                        left: '10px',
                        zIndex: 1001,
                        px: 1,
                    }}
                    style={{
                        backgroundColor: localStorage.getItem("joy-mode")==='dark'?'var(--joy-palette-background-surface)':'white',
                    }}
                    level={'body-sm'}
                >
                    {this.props.label}
                </Typography>
                <Card
                    size={'sm'}
                    sx={{
                        p: 1,
                        gap: 0,
                    }}
                >
                    <ButtonGroup
                        size={'sm'}
                        sx={{
                            ml: 0.5,
                            my: 0.25,
                        }}
                    >
                        <Button
                            variant={this.props.disabled?'soft':'solid'}
                            color={!this.state.checked?'danger':'neutral'}
                            onClick={!this.props.disabled?this.setChecked.bind(this, false):null}
                            sx={this.props.disabled?{
                                "&:hover": {
                                    cursor: 'default',
                                },
                                m: 0
                            }:{
                                m: 0
                            }}

                        >
                            Нет
                        </Button>
                        <Button
                            variant={this.props.disabled?'soft':'solid'}
                            color={this.state.checked?'success':'neutral'}
                            onClick={!this.props.disabled?this.setChecked.bind(this, true):null}
                            sx={this.props.disabled?{
                                "&:hover": {
                                    cursor: 'default',
                                },
                                m: 0
                            }:{

                            }}
                        >
                            Да
                        </Button>
                    </ButtonGroup>
                    <input
                        style={{
                            width: '1px',
                            height: '1px',
                            margin: 0,
                            padding: 0,
                            border: 0,
                            color: 'transparent',
                        }}
                        required={this.props.required}
                        name={this.props.name}
                        checked={this.state.checked}
                        value={this.state.checked?'true':'false'}
                    />
                </Card>
            </Stack>
        )
    }
}

export class SimpleTextarea extends React.Component {
    render() {
        return(
            <>
                <FormLabel>{this.props.label}</FormLabel>
                <textarea
                    required={this.props.required}
                    name={this.props.name}
                    defaultValue={this.props.defaultValue}
                    rows={5}
                />
            </>
        )
    }
}


export class StringListField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: this.props.defaultValue?JSON.parse(this.props.defaultValue):[],
            value: this.props.defaultValue,
        }
    }

    handleChange(event){
        let formDataEntries= (new FormData(event.target.form)).entries();
        let value = [];
        for (let field of formDataEntries) {
            value.push(field[1]);
        }
        this.setState({
            fields: value,
            value: JSON.stringify(value),
        });
    }

    deleteRow(index){
        let newFields = [];
        for (let i = 0; i < this.state.fields.length; i++) {
            if (i !== index){
                newFields.push(
                    this.state.fields[i]
                )
            }
        }
        this.setState({
            fields: newFields,
            value: JSON.stringify(newFields),
        });
    }

    addRow(){
        let newFields = this.state.fields;
        newFields.push('');
        this.setState({
            fields: newFields,
            value: JSON.stringify(newFields),
        });
    }

    render() {
        return(
            <>
                <FormLabel>{this.props.label}</FormLabel>
                <form
                    onChange={this.handleChange.bind(this)}
                >
                    {
                        this.state.fields.map(
                            (field, index) => (
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                >
                                    <Input
                                        type={'input'}
                                        required={this.props.required}
                                        name={index+'_key'}
                                        defaultValue={field}
                                    />
                                    <IconButton
                                        size={'sm'}
                                        color="danger"
                                        sx={{'ml': 3,}}
                                        onClick={this.deleteRow.bind(this, index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Stack>
                            )
                        )
                    }
                    <IconButton
                        size={'sm'}
                        color="success"
                        sx={{'ml': 3,}}
                        onClick={this.addRow.bind(this)}
                    >
                        <AddIcon />
                    </IconButton>
                </form>
                <input
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                    required={this.props.required}
                    name={this.props.name}
                    value={this.state.value}
                />
            </>
        )
    }
}


export class KeyValuePairsField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: this.props.defaultValue?Object.entries(JSON.parse(this.props.defaultValue)):[],
            value: this.props.defaultValue?this.props.defaultValue:'{}',
        }
    }

    handleChange(event){
        let formDataObj = Object.fromEntries(
            (new FormData(event.target.form)).entries()
        );
        let value = {};
        for (let i = 0; i < Math.floor(Object.entries(formDataObj).length / 2); i++) {
            value[formDataObj[i+'_key']] = formDataObj[i+'_value']
        }
        this.setState({
            value: JSON.stringify(value),
        });
    }

    deletePair(index){
        let newFields = [];
        for (let i = 0; i < this.state.fields.length; i++) {
            if (i !== index){
                newFields.push(
                    this.state.fields[i]
                )
            }
        }
        let value = {};
        for (let field in newFields) {
            value[field[0]] = field[1]
        }
        this.setState({
            fields: newFields,
            value: JSON.stringify(value)
        });
    }

    addPair(){
        let newFields = this.state.fields;
        newFields.push(
            ['', '']
        )
        this.setState({
            fields: newFields,
        });
    }

    render() {
        return(
            <>
                <FormLabel>{this.props.label}</FormLabel>
                <form
                    onChange={this.handleChange.bind(this)}
                >
                    {
                        this.state.fields.map(
                            (field, index) => (
                                <Stack
                                    direction={'row'}
                                    spacing={1}
                                >
                                    <Input
                                        type={'input'}
                                        required={this.props.required}
                                        name={index+'_key'}
                                        defaultValue={field[0]}
                                    />
                                    <Input
                                        type={'input'}
                                        required={this.props.required}
                                        name={index+'_value'}
                                        defaultValue={field[1]}
                                    />
                                    <IconButton
                                        size={'sm'}
                                        color="danger"
                                        sx={{'ml': 3,}}
                                        onClick={this.deletePair.bind(this, index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </Stack>
                            )
                        )
                    }
                    <IconButton
                        size={'sm'}
                        color="success"
                        sx={{'ml': 3,}}
                        onClick={this.addPair.bind(this)}
                    >
                        <AddIcon />
                    </IconButton>
                </form>
                <input
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                    required={this.props.required}
                    name={this.props.name}
                    value={this.state.value}
                />
            </>
        )
    }
}


export class NumberSliderField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.defaultValue?this.props.defaultValue:0,
        }
    }

    async setNumber(event, number){
        this.setState({
            value: number
        })
        flushSync(()=>{})
        await this.props.callBack()
    }

    render() {
        return(
            <>
                <Stack
                    direction={'row'}
                    spacing={2}
                    alignItems="center"
                    flexWrap={'nowrap'}
                    sx={{
                        mt: 2
                    }}
                >
                    {
                        this.props.startDecorator?
                            <this.props.startDecorator.component
                                {...this.props.startDecorator.props}
                            />:
                            null
                    }
                    <Slider
                        defaultValue={this.props.defaultValue}
                        marks={this.props.marks}
                        step={this.props.step}
                        min={this.props.min}
                        max={this.props.max}
                        onChange={this.setNumber.bind(this)}
                        valueLabelDisplay="on"
                        disabled={this.props.disabled}
                        track={this.props.disabled?'inverted':'normal'}
                    />

                    {
                        this.props.endDecorator?
                            <this.props.endDecorator.component
                                {...this.props.endDecorator.props}
                            />:
                            null
                    }
                </Stack>
                <input
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                    required={this.props.required}
                    name={this.props.name}
                    value={this.state.value}
                />
            </>
        )
    }
}
